
import { SearchBookingOverview } from "@/types/models";
import { LocaleStrings } from "@/types/paramModels";
import { computed, defineComponent, PropType } from "vue";

export default defineComponent({
  props: {
    bookingOverview: {
      type: Object as PropType<SearchBookingOverview>,
      required: true,
    },
    searchQuery: {
      type: Object,
      required: true
    },
    show: {
      type: Boolean
    },
    pageTexts: {
      type: Object,
      required: true
    },
    localeStrings: {
      type: Object as PropType<LocaleStrings>,
      required: true
    }
  },
  setup(_props) {
    const query = computed(() => _props.searchQuery);

    const showBookingButton = computed(() => {
      return _props.bookingOverview.bookingSelection;
    })

    return {
      showBookingButton,
      query,
    }

  },
});
